import { AdditionalHeader, ApiVersion, Authentication, BaseRequest } from './baseRequest';
import * as t from 'io-ts';

/**
 * Base class for all requests with (optional) message body.
 */
export class BaseRequestWithBody<T> extends BaseRequest<T> {
    private method: string;

    constructor(
        relativeUrl: string,
        queryStringParameters: {[key: string]: string},
        public bodyData: any,
        resultDynamicType: t.Type<T>,
        method: string,
        authenticationRequired: Authentication = Authentication.Login,
        apiVersion: ApiVersion,
    ) {
        super(relativeUrl, queryStringParameters, resultDynamicType, authenticationRequired, apiVersion);
        this.addHeader('content-type', 'application/json');
        this.method = method;
    }

    protected buildRequestInit(additionalHeaders: AdditionalHeader[]): RequestInit {
        return {
            ...super.buildRequestInit(additionalHeaders),
            method: this.method,
            body: this.buildBody()
        };
    }

    protected buildBody(): string {
        return JSON.stringify(this.bodyData);
    }
}
